import React from "react";
import { STEPS } from "../mock";
import Reveal from "./Reveal";

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="relative py-20 lg:py-28">
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <Reveal className="max-w-2xl">
          <p className="text-[13px] font-semibold tracking-wide text-[#13D99A] uppercase mb-4">How Renn Works</p>
          <h2 className="font-display text-3xl lg:text-5xl font-bold text-[#F5F7FB] leading-[1.08]">
            From financial information to a clear plan.
          </h2>
        </Reveal>

        <div className="mt-14 relative">
          {/* connecting line on desktop */}
          <div className="hidden lg:block absolute top-7 left-[16%] right-[16%] h-px bg-gradient-to-r from-[#10C98A]/50 via-[#29354A] to-[#10C98A]/50" />
          <div className="grid lg:grid-cols-3 gap-6 lg:gap-8">
            {STEPS.map((s, i) => (
              <Reveal key={s.n} delay={i * 110}>
                <div className="relative h-full rounded-2xl border border-[#29354A] bg-[#121A28] p-7 card-hover">
                  <div className="w-14 h-14 rounded-full border border-[#10C98A]/50 bg-[#0A1220] flex items-center justify-center font-display text-xl font-bold text-[#13D99A] mb-6">
                    {s.n}
                  </div>
                  <h3 className="font-display text-xl font-bold text-[#F5F7FB] mb-3">{s.title}</h3>
                  <p className="text-[#8290A8] leading-relaxed">{s.copy}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
